import { VStack } from "@gluestack-ui/themed";
import { EmergencyWithdrawOptionsController } from "./controller";
import { MenuActionsList } from "@repo/core/components/layout/MenuActionsList";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const EmergencyWithdrawOptions = () => {
  const { isMobile, menuActionItems } = EmergencyWithdrawOptionsController();
  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title="Saque Emergencial">
        <VStack
          space="lg"
          alignItems={isMobile ? "flex-start" : "center"}
          pt="$3"
          px={isMobile ? "$4" : "$6"}
          w="$full"
        >
          <MenuActionsList
            title="Tipo de parcelamento"
            menuItems={menuActionItems}
          />
        </VStack>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default EmergencyWithdrawOptions;
